import { FormSection } from '../ui/FormSection';

export interface ExperienceRequirementsFieldsProps {
  requiresReservation: boolean;
  onRequiresReservationChange: (value: boolean) => void;
  wineClubOnly: boolean;
  onWineClubOnlyChange: (value: boolean) => void;
  availability: string;
  onAvailabilityChange: (value: string) => void;
  isSubmitting: boolean;
}

export const ExperienceRequirementsFields = ({
  requiresReservation,
  onRequiresReservationChange,
  wineClubOnly,
  onWineClubOnlyChange,
  availability,
  onAvailabilityChange,
  isSubmitting,
}: ExperienceRequirementsFieldsProps) => (
  <FormSection title="Requirements and Availability">
    {/* Requires Reservation */}
    <div className="flex items-center">
      <input
        id="requiresReservation"
        type="checkbox"
        checked={requiresReservation}
        onChange={(e) => onRequiresReservationChange(e.target.checked)}
        disabled={isSubmitting}
        className="h-4 w-4 text-primary-700 focus:ring-info-500 border-gray-300 rounded"
      />
      <label htmlFor="requiresReservation" className="ml-2 text-sm text-gray-700">
        Requires reservation
      </label>
    </div>

    {/* Wine Club Only */}
    <div className="flex items-center">
      <input
        id="wineClubOnly"
        type="checkbox"
        checked={wineClubOnly}
        onChange={(e) => onWineClubOnlyChange(e.target.checked)}
        disabled={isSubmitting}
        className="h-4 w-4 text-primary-700 focus:ring-info-500 border-gray-300 rounded"
      />
      <label htmlFor="wineClubOnly" className="ml-2 text-sm text-gray-700">
        Wine club members only
      </label>
    </div>

    {/* Availability */}
    <div>
      <label htmlFor="availability" className="block text-sm font-medium text-gray-700 mb-1">
        Availability
      </label>
      <textarea
        id="availability"
        value={availability}
        onChange={(e) => onAvailabilityChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., Daily 10am-5pm, Weekends only, By appointment"
        rows={2}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
      <p className="mt-1 text-xs text-gray-500">Describe when this experience is available</p>
    </div>
  </FormSection>
);
